var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOriginalHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / Flavor / Original Hot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "ogH-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0007328,25.863703 C25.0007328,25.863703 26.1680508,26.8643136 26.1680508,29.8042257 C26.1680508,32.7437714 23.0617978,35 23.0617978,35 C23.0617978,35 30.3467269,33.5853688 30.3467269,24.5729116 C30.3467269,18.0595994 21.8479482,14.8540547 21.8479482,8.69211041 C21.8479482,5.8617489 24.2397411,6.59452858 24.2397411,6.59452858 C24.2397411,6.59452858 23.5926966,5 20.3332926,5 C16.8965559,5 15.1459453,8.07547631 15.1459453,11.8643136 C15.1459453,13.8871519 15.8842208,14.7258183 15.8842208,14.7258183 C15.8842208,14.7258183 15.1518075,14.5374939 13.8126527,14.5374939 C11.9044944,14.5374939 11.2035906,15.9700782 11.2035906,15.9700782 C11.2035906,15.9700782 13.5070835,16.1818515 13.5070835,18.3483146 C13.5070835,20.5147777 10,23.0058622 10,26.9317294 C10,33.1013679 17.1233512,34.9124328 17.1233512,34.9124328 C17.1233512,34.9124328 14.7440156,32.7122618 14.7440156,29.5499511 C14.7440156,25.2957987 19.7137274,25.7079873 19.7137274,21.1145579 C19.7137274,19.9095017 19.5155105,18.6168784 19.5155105,18.6168784 C19.5155105,18.6168784 22.6950415,20.8991207 22.6950415,23.8819003 C22.6950415,26.8643136 20.9931607,27.6073522 20.9931607,27.6073522 C20.9931607,27.6073522 21.0437225,27.9788715 22.4594529,27.9788715 C23.8751832,27.9788715 25.0007328,25.863703 25.0007328,25.863703",
    id: "ogH-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ogH-icon-/-Flavor-/-Original-Hot",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ogH-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "ogH-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ogH-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "ogH-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ogH-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ogH-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ogH-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#ogH-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ogH-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#ogH-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "ogH-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ogH-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ogH-Fill-1",
    fill: "#231F20",
    xlinkHref: "#ogH-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ogH-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#ogH-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalHot);
export default __webpack_public_path__ + "static/media/OriginalHot.f5202b945254f609cc8d5f9c3dbe7ef4.svg";
export { ForwardRef as ReactComponent };